import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

import { IS_DEV } from '../config';

const getLang = (): string => {
  if (process.env.REACT_APP_LANG) {
    return process.env.REACT_APP_LANG;
  }

  if (window.origin === 'https://app.embedgames.app') {
    return 'ru';
  }

  return 'en';
};

i18next
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: getLang(),
    fallbackLng: 'en',
    debug: IS_DEV,
    interpolation: {
      escapeValue: false,
    },
  });
